import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "wonderbly-components/lib/Button";
import SelectField from "wonderbly-components/lib/SelectField";
import { useModel } from "../../../../hooks";

const ProductHeroIIButtonLink = (props) => {
  const {
    countryModel: { prefix, locale },
  } = useModel();

  // rekeying for the Select field which works with value and label
  const locales = props.productLocales?.map(({ key, value }) => ({
    value: key,
    label: value,
  }));
  const [selectedLocale, setSelectedLocale] = useState(
    locales?.[0]?.value || locale
  );
  const [href, setHref] = useState("");

  useEffect(() => {
    const nextPrefix = prefix !== "" ? `${prefix}/` : "";
    const nextHref = `/${nextPrefix}personalized-products/${props.productSlug}/create/start?locale=${selectedLocale}`;
    setHref(nextHref);
  }, [selectedLocale]);

  return (
    <div className="ProductHeroII__button-wrap">
      {locales.length > 1 && (
        <SelectField
          id="ProductHeroII__locale-select"
          type="select"
          name="locale-select"
          options={locales}
          onChange={(e) => setSelectedLocale(e.target.value)}
        />
      )}
      <Button className="ProductHeroII__button" type="submit" href={href}>
        {props.productCtaButtonText}
      </Button>
    </div>
  );
};

ProductHeroIIButtonLink.propTypes = {
  productCtaButtonText: PropTypes.string,
  productSlug: PropTypes.string,
  productLocales: PropTypes.array,
};

export default ProductHeroIIButtonLink;
